export function createHabitInstance(habitId, date, data) {
    const now = new Date().toISOString();
    return {
        habit_id: habitId,
        date,
        instance_detail: data.instance_detail,
        notes: data.notes ?? null,
        created_at: now,
        updated_at: now,
    };
}
export function getHabitInstanceKey(habitId, date) {
    return `${habitId}:${date}`;
}
//# sourceMappingURL=habit.js.map